const HeaderType = {
  EXTERNAL_ID_HEADER: 'X-External-ID',
  FLOW_ID_HEADER: 'X-Civic-FlowId',
  IDENTITY_HEADER: 'X-Identity-Self'
};
module.exports = {
  HeaderType
};